import { darken } from 'polished';
import { FormattedMessage } from 'react-intl';
import FormattedHtmlMessage from 'src/easyclaim.app.components/common/FormattedHtmlMessage';
import styled from 'styled-components';

import { AppState } from '../AppState';
import { OnboardingStep1 } from '../easyclaim.app.assets';
import { OnboardingStep1 as OnboardingStep1Webp } from '../easyclaim.app.assets/artwork/onboarding/WEBP_OnboardingStep1';
import { Modal } from '../easyclaim.app.components/index';
import theme from '../easyclaim.app.theme/theme';

import { ScreenComponent } from './ScreenComponent';

interface BlockedByDeviceState {}

export class BlockedByDevice extends ScreenComponent<AppState, BlockedByDeviceState> {
	modal?: Modal | null;
	constructor(props: AppState) {
		super(props);

		this.state = {};
	}
	next(): void {}

	public render() {
		const configuration = this.props.easyClaimCase && this.props.easyClaimCase._configuration;

		if (!configuration || !configuration.frontendSteps) {
			return;
		}

		const hideBackgroundGradient = configuration?.landingHideBackgroundGradient
			? configuration.landingHideBackgroundGradient
			: theme.colors.landing.hideBackgroundGradient;
		const landingPrimaryColor = configuration?.landingPrimaryColor
			? configuration.landingPrimaryColor
			: theme.colors.landing.primary;
		const landingPrimaryTextColor = configuration?.landingPrimaryTextColor
			? configuration.landingPrimaryTextColor
			: theme.colors.landing.text.primary;

		return (
			<Main
				hideBackgroundGradient={hideBackgroundGradient}
				landingPrimaryColor={landingPrimaryColor}
				landingPrimaryTextColor={landingPrimaryTextColor}
			>
				<div className="main-container">
					<Modal
						className="blocked-on-desktop"
						isOpen={true}
						closeOnBackdropClick={false}
						onClose={() => {
							console.log('onClose');
						}}
						header={
							<h2>
								<FormattedMessage id="blockedByDevice.headline" />
							</h2>
						}
						footer={<></>}
						doNotShowClose={true}
						ref={(r) => (this.modal = r)}
					>
						<>
							<div>
								{configuration.canUseExperimentalPerformanceEnhancer ? (
									<OnboardingStep1Webp className="onboarding-step-image" />
								) : (
									<OnboardingStep1 className="onboarding-step-image" />
								)}
							</div>
							<p style={{ whiteSpace: 'pre-line' }}>
								<FormattedHtmlMessage id="blockedByDevice.description" />
							</p>
						</>
					</Modal>
				</div>
			</Main>
		);
	}
}

const Main = styled.main<{
	hideBackgroundGradient: boolean;
	landingPrimaryColor: string;
	landingPrimaryTextColor: string;
}>`
	background: ${(props) =>
		props.hideBackgroundGradient
			? props.landingPrimaryColor
			: `
        linear-gradient(
        to bottom,
        ${props.landingPrimaryColor} 0%,
        ${darken(0.15, props.landingPrimaryColor)} 100%
    );
    `};
	color: ${(props) => props.landingPrimaryTextColor};
	padding: 3rem 2rem;
	min-height: 60vh;
`;
